import request from '@/utils/request';

//查询字段集合
export function getFieldPackageList(values) {
  return request('/decision/field/field-package', {
    method: 'GET',
    params: values,
  });
}
//添加字段集合
export function addFieldPackage(values) {
  return request(
    `/decision/field/field-package${values.id ? '/' + values.id : ''}`,
    {
      method: values.id ? 'PUT' : 'POST',
      data: JSON.parse(JSON.stringify(values.values)),
    },
  );
}
//删除字段集合
export function deleteFieldPackage(id) {
  return request(`/decision/field/field-package/${id}`, {
    method: 'DELETE',
  });
}

//导出字段包数据
export function exportFieldPackage(fieldPackageId) {
  return request(`/decision/field/field-package/export/${fieldPackageId}`, {
    method: 'GET',
  });
}

//导入字段包数据
export function uploadFile(values) {
  return request('/decision/field/field-package/import', {
    method: 'POST',
    data: values,
  });
}
